import type { Component, App } from 'vue'
import XTable from './x-table/XTable.vue'
import XSelect from './x-select/XSelect.vue'
import SvgIcon from './svg-icon/SvgIcon.vue'
import XFlexCtx from './x-flex-ctx/XFlexCtx.vue'
import XFormDialog from './x-form-dialog/XFormDialog.vue'
import XTinyMce from './x-tiny-mce/XTinyMce.vue'
import XAppLayout from './x-app-layout/XAppLayout.vue'
import XDataImport from './x-data-import/XDataImport.vue'
import XTableSelect from './x-table-select/XTableSelect.vue'
const components: {
  [propName: string]: Component
} = {
  XTable,
  XSelect,
  SvgIcon,
  XFlexCtx,
  XFormDialog,
  XTinyMce,
  XAppLayout,
  XDataImport,
  XTableSelect
}

const installComponents: any = (app: App) => {
  for (const key in components) {
    app.component(key, components[key])
  }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const install: any = (app: any, router?: any) => {
  installComponents(app)
}

// 按需引入
export {
  XTable,
  XSelect,
  SvgIcon,
  XFlexCtx,
  XFormDialog,
  XTinyMce,
  XAppLayout,
  XDataImport,
  XTableSelect
}
export default {
  ...components,
  install,
}
